<div
  class="bn-dropdown bn-dropdown--{{ menuOptions.position }} bn-dropdown--{{ menuOptions.align }} bn-dropdown--{{ menuOptions.size }}"
  [ngClass]="{
    'bn-dropdown--open': isOpened,
    'bn-dropdown--full-width': menuOptions.isFullWidth,
    'w-100 h-100': menuOptions.isFullSize,
    'bn-dropdown--custom-position': hasCustomPosition,
    'bn-dropdown--fixed': isFixedPosition,
  }">
  <div
    #dropdownTrigger
    aria-controls="dropdown"
    aria-haspopup="true"
    class="bn-dropdown__trigger"
    [attr.aria-disabled]="isDisabled"
    [ngClass]="{
      'bn-dropdown__trigger--disabled': isDisabled,
      'bn-dropdown__trigger--has-arrow': menuOptions.attachArrow,
      'px-2': menuOptions.arrowPadding,
      'w-100 h-100 align-items-center justify-content-center d-flex': menuOptions.isFullSize,
    }"
    (click)="toggleDropdown($event)">
    <ng-content select="[trigger]" />
    @if (menuOptions.attachArrow) {
      <span>
        <fa-icon
          icon="chevron-down"
          size="xs"
          [ngClass]="{
            'ms-2': !menuOptions.noMarginArrow,
          }" />
      </span>
    }
  </div>
  @if (isOpened) {
    <div
      class="bn-dropdown__content text-start"
      [ngStyle]="contentStyle">
      <div
        class="bn-dropdown__content__wrapper"
        [ngClass]="{
          'bn-dropdown__content__wrapper--shadow': hasContentShadow,
        }">
        <ng-content select="[content-top]" />

        @if (dropdownItems && dropdownItems.length) {
          @if (menuOptions.virtualScroll; as virtualScroll) {
            <cdk-virtual-scroll-viewport
              class="bn-dropdown__viewport"
              [itemSize]="virtualScroll.itemHeight"
              [style.height.px]="viewportHeight">
              <ul>
                <li
                  *cdkVirtualFor="let menuItem of dropdownItems; trackBy: trackMenuItem"
                  class="bn-dropdown__row"
                  [style.height.px]="virtualScroll.itemHeight">
                  <ng-container *ngTemplateOutlet="menuRow; context: { menuItem }" />
                </li>
              </ul>
            </cdk-virtual-scroll-viewport>
          } @else {
            <ul>
              @for (menuItem of dropdownItems; track $index) {
                <li>
                  <ng-container *ngTemplateOutlet="menuRow; context: { menuItem }" />
                </li>
              }
            </ul>
          }
        }
        <ng-content select="[content]" />
      </div>
    </div>
  }
</div>

<ng-template
  #menuRow
  let-menuItem="menuItem">
  @if (!menuItem.hide) {
    @switch (menuItem.type || 'link') {
      @case ('title') {
        <div class="bn-dropdown__header">
          <div class="bn-dropdown__title">
            <ng-container *ngTemplateOutlet="linkItem; context: { menuItem }" />
          </div>
        </div>
      }
      @case ('link') {
        <ng-template
          *ngTemplateOutlet="
            linkItem;
            context: {
              menuItem,
              addItemClass: true,
              nowrap: menuItem.nowrap || false,
            }
          " />
      }
      @case ('upload') {
        <ng-template
          *ngTemplateOutlet="
            linkItem;
            context: {
              menuItem,
              addItemClass: true,
              nowrap: menuItem.nowrap || false,
              isUpload: true,
            }
          " />
      }
      @case ('theme-switch') {
        <div class="bn-dropdown__theme-switch">
          <bn-web-ui-switch
            class="py-1 px-3"
            label="Switch theme"
            size="md"
            [icons]="[
              ['far', 'sun-bright'],
              ['far', 'moon-stars'],
            ]"
            [(ngModel)]="isDarkTheme"
            (ngModelChange)="toggleTheme()" />
        </div>
      }
      @case ('divider') {
        <hr class="bn-dropdown__divider" />
      }
    }
  }
</ng-template>

<ng-template
  #linkItem
  let-addItemClass="addItemClass"
  let-menuItem="menuItem"
  let-nowrap="nowrap">
  <div
    class="{{ menuItem.class }} {{ menuItem.contextType | contextTextClass }}"
    tooltip="{{ menuItem.tooltip ?? null }}"
    [ngClass]="{ 'bn-dropdown__item': addItemClass }">
    @if (menuItem.route) {
      <a
        class="bn-dropdown__item-link {{ menuItem.itemClass }}"
        [ngClass]="{ 'text-nowrap': nowrap }"
        [queryParams]="menuItem.queryParams || {}"
        [routerLink]="menuItem.route">
        @if (menuItem.icon) {
          <fa-icon
            class="bn-dropdown__icon"
            [icon]="menuItem.icon" />
        }

        <span>{{ menuItem.label }}</span></a
      >
    } @else if (menuItem.action) {
      <a
        class="bn-dropdown__item-link {{ menuItem.itemClass }}"
        [ngClass]="{ 'text-nowrap': nowrap, 'bn-dropdown__item-link--selected': menuItem.selected }"
        (click)="onLinkClicked(menuItem, $event)">
        @if (menuItem.icon) {
          <fa-icon
            class="bn-dropdown__icon"
            [icon]="menuItem.icon" />
        }
        <span>{{ menuItem.label }}</span>
        @if (menuItem.badge !== undefined) {
          <bn-web-ui-badge
            class="bn-dropdown__badge"
            color="info"
            data-e2e="DropdownItemBadge"
            size="xxs">
            {{ menuItem.badge }}
          </bn-web-ui-badge>
        }
        @if (menuItem.selected) {
          <fa-icon
            class="bn-dropdown__check"
            data-e2e="DropdownItemCheck"
            icon="check" />
        }
      </a>
    } @else if (menuItem.isUpload) {
      <span
        bnWebUiUploadFileDialog
        class="bn-dropdown__item-content {{ menuItem.itemClass }}"
        [data]="uploadData || {}"
        [ngClass]="{ 'text-nowrap': nowrap }">
        <fa-icon
          class="bn-dropdown__icon"
          [icon]="menuItem.icon" />
        <span>{{ menuItem.label }}</span>
      </span>
    } @else {
      <span
        class="bn-dropdown__item-content {{ menuItem.itemClass }}"
        [ngClass]="{ 'text-nowrap': nowrap }">
        @if (menuItem.icon) {
          <fa-icon
            class="bn-dropdown__icon"
            [icon]="menuItem.icon" />
        }
        <span>{{ menuItem.label }}</span></span
      >
    }
  </div>
</ng-template>
